import en from '../locales/appEn.json';
import vi from '../locales/appVi.json';
import homeDeskVi from '../locales/homeDeskVi.json';
import homeDeskEn from '../locales/homeDeskEn.json';
import homeMysteryEn from '../locales/homeMysteryEn.json';
import homeMysteryVi from '../locales/homeMysteryVi.json';
import homeRecommendEn from '../locales/homeRecommendEn.json';
import homeRecommendVi from '../locales/homeRecommendVi.json';
import homeScriptEn from '../locales/homeScriptEn.json';
import homeScriptVi from '../locales/homeScriptVi.json';
import desktopFooterEn from '../locales/desktopFooterEn.json';
import desktopFooterVi from '../locales/desktopFooterVi.json';
import desktopLoginEn from '../locales/desktopLoginEn.json';
import desktopLoginVi from '../locales/desktopLoginVi.json';
import signInEn from '../locales/signInEn.json';
import signInVi from '../locales/signInVi.json';
import bookingEn from '../locales/bookingEn.json';
import bookingVi from '../locales/bookingVi.json';
import homeShopEn from '../locales/homeShopEn.json';
import homeShopVi from '../locales/homeShopVi.json';
import highRecommendedEn from '../locales/highRecommendedEn.json';
import highRecommendedVi from '../locales/highRecommendedVi.json';
import ninaLightEn from '../locales/ninaLightEn.json';
import ninaLightVi from '../locales/ninaLightVi.json';
import enchantedSpellEn from '../locales/enchantedSpellEn.json';
import enchantedSpellVi from '../locales/enchantedSpellVi.json';
import mysticalArrivalEn from '../locales/mysticalArrivalEn.json';
import mysticalArrivalVi from '../locales/mysticalArrivalVi.json';
import mysticalExperienceEn from '../locales/mysticalExperienceEn.json';
import mysticalExperienceVi from '../locales/mysticalExperienceVi.json';
import shopMagicGiftEn from '../locales/shopMagicGiftEn.json';
import shopMagicGiftVi from '../locales/shopMagicGiftVi.json';
import vipEn from '../locales/vipEn.json';
import vipVi from '../locales/vipVi.json';
import presentEn from '../locales/presentEn.json';
import presentVi from '../locales/presentVi.json';
import embraceMagicEn from '../locales/embraceMagicEn.json';
import embraceMagicVi from '../locales/embraceMagicVi.json';
import ritualDestopEn from '../locales/ritualDesktopEn.json'
import ritualDestopVi from '../locales/ritualDesktopVi.json';
import productInfoDesktopEn from '../locales/productInfoDesktopEn.json';
import productInfoDesktopVi from '../locales/productInfoDesktopVi.json';
import productListEn from '../locales/productListEn.json';
import productListVi from '../locales/productListVi.json';
// Mobile
import mobileMenuEn from '../localesMobile/mobileMenuEn.json';
import mobileMenuVi from '../localesMobile/mobileMenuVi.json';
import homepageMobileEn from '../localesMobile/homePageMobileEn.json';
import homepageMobileVi from '../localesMobile/homePageMobileVi.json';
import mobileFooterEn from '../localesMobile/mobileFooterEn.json';
import mobileFooterVi from '../localesMobile/mobileFooterVi.json';
import bookingMobileVi from '../localesMobile/bookingVi.json';
import bookingMobileEn from '../localesMobile/bookingEn.json';
import vipMobileEn from '../localesMobile/vipEn.json';
import vipMobileVi from '../localesMobile/vipVi.json';
import presentMobileEn from '../localesMobile/presentEn.json';
import presentMobileVi from '../localesMobile/presentVi.json';
import firstShopEn from '../localesMobile/homeShopMobileEn.json';
import firstShopVi from '../localesMobile/homeShopMobileVi.json';
import highRecommendedMobileEn from '../localesMobile/highRecommendedEn.json';
import highRecommendedMobileVi from '../localesMobile/highRecommendedVi.json';
import highRecommendedItemMobileEn from '../localesMobile/highRecommendedItemEn.json';
import highRecommendedItemMobileVi from '../localesMobile/highRecommendedItemVi.json';
import ninaLightMobileEn from '../localesMobile/ninaLightMobileEn.json';
import ninaLightMobileVi from '../localesMobile/ninaLightMobileVi.json';
import enchantedSpellMobileEn from '../localesMobile/enchantedSpellMobileEn.json';
import enchantedSpellMobileVi from '../localesMobile/enchantedSpellMobileVi.json';
import mysticalArrivalMobileEn from '../localesMobile/mysticalArrivalMobileEn.json';
import mysticalArrivalMobileVi from '../localesMobile/mysticalArrivalMobileVi.json';
import mysticalExperienceMobileEn from '../localesMobile/mysticalExperienceMobileEn.json';
import mysticalExperienceMobileVi from '../localesMobile/mysticalExperienceMobileVi.json';
import shopMagicGiftMobileEn from '../localesMobile/shopMagicGiftEn.json';
import shopMagicGiftMobileVi from '../localesMobile/shopMagicGiftVi.json';
import embraceMagicMobileEn from '../localesMobile/embraceMagicMobileEn.json';
import embraceMagicMobileVi from '../localesMobile/embraceMagicMobileVi.json';
import productInfoMobileEn from '../locales/productInfoMobileEn.json';
import productInfoMobileVi from '../locales/productInfoMobileVi.json';
import ninaRitualMobileEn from '../localesMobile/ninaRitualMobileEn.json';
import ninaRitualMobileVi from '../localesMobile/ninaRitualMobileVi.json';
import homeMatrixVi from '../locales/homeMatrixVi.json';
import homeMatrixEn from '../locales/homeMatrixEn.json';

export const messages = {
  en: {
    appDesktop: en,
    homeDesktop: homeDeskEn,
    homeMystery: homeMysteryEn,
    homeRecommend: homeRecommendEn,
    homeScript: homeScriptEn,
    desktopFooter: desktopFooterEn,
    desktopLogin: desktopLoginEn,
    signIn: signInEn,
    booking: bookingEn,
    homeShop: homeShopEn,
    highRecommended: highRecommendedEn,
    ninaLight: ninaLightEn,
    enchantedSpell: enchantedSpellEn,
    mysticalArrival: mysticalArrivalEn,
    mysticalExperience: mysticalExperienceEn,
    shopMagicGift: shopMagicGiftEn,
    vip: vipEn,
    present: presentEn,
    embraceMagic: embraceMagicEn,
    ritualDesktop: ritualDestopEn,
    productList: productListEn,
    productInfoMobile: productInfoMobileEn,
    // Mobile
    mobileMenu: mobileMenuEn,
    homepageMobile: homepageMobileEn,
    mobileFooter: mobileFooterEn,
    bookingMobile: bookingMobileEn,
    vipMobile: vipMobileEn,
    presentMobile: presentMobileEn,
    firstShop: firstShopEn,
    highRecommendedMobile: highRecommendedMobileEn,
    highRecommendedItemMobile: highRecommendedItemMobileEn,
    ninaLightMobile: ninaLightMobileEn,
    enchantedSpellMobile: enchantedSpellMobileEn,
    mysticalArrivalMobile: mysticalArrivalMobileEn,
    mysticalExperienceMobile: mysticalExperienceMobileEn,
    shopMagicGiftMobile: shopMagicGiftMobileEn,
    embraceMagicMobile: embraceMagicMobileEn,
    productInfoDesktop: productInfoDesktopEn,
    ninaRitualMobile: ninaRitualMobileEn,
    homeMatrix: homeMatrixEn.homeMatrix
  },
  vi: {
    appDesktop: vi,
    homeDesktop: homeDeskVi,
    homeMystery: homeMysteryVi,
    homeRecommend: homeRecommendVi,
    homeScript: homeScriptVi,
    desktopFooter: desktopFooterVi,
    desktopLogin: desktopLoginVi,
    signIn: signInVi,
    booking: bookingVi,
    homeShop: homeShopVi,
    highRecommended: highRecommendedVi,
    ninaLight: ninaLightVi,
    enchantedSpell: enchantedSpellVi,
    mysticalArrival: mysticalArrivalVi,
    mysticalExperience: mysticalExperienceVi,
    shopMagicGift: shopMagicGiftVi,
    vip: vipVi,
    present: presentVi,
    embraceMagic: embraceMagicVi,
    ritualDesktop: ritualDestopVi,
    productList: productListVi,
    productInfoMobile: productInfoMobileVi,
    // Mobile
    mobileMenu: mobileMenuVi,
    homepageMobile: homepageMobileVi,
    mobileFooter: mobileFooterVi,
    bookingMobile: bookingMobileVi,
    vipMobile: vipMobileVi,
    presentMobile: presentMobileVi,
    firstShop: firstShopVi,
    highRecommendedMobile: highRecommendedMobileVi,
    highRecommendedItemMobile: highRecommendedItemMobileVi,
    ninaLightMobile: ninaLightMobileVi,
    enchantedSpellMobile: enchantedSpellMobileVi,
    mysticalArrivalMobile: mysticalArrivalMobileVi,
    mysticalExperienceMobile: mysticalExperienceMobileVi,
    shopMagicGiftMobile: shopMagicGiftMobileVi,
    embraceMagicMobile: embraceMagicMobileVi,
    productInfoDesktop: productInfoDesktopVi,
    ninaRitualMobile: ninaRitualMobileVi,
    homeMatrix: homeMatrixVi.homeMatrix
  }
};